import { render, staticRenderFns } from "./lessons-collapse.vue?vue&type=template&id=fe20bad2&scoped=true"
import script from "./lessons-collapse.vue?vue&type=script&lang=ts"
export * from "./lessons-collapse.vue?vue&type=script&lang=ts"
import style0 from "./lessons-collapse.vue?vue&type=style&index=0&id=fe20bad2&prod&lang=scss&scoped=true"
import style1 from "./lessons-collapse.vue?vue&type=style&index=1&id=fe20bad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe20bad2",
  null
  
)

export default component.exports